import type { PropsWithChildren } from 'react'

import classNames from 'classnames'

import { iconSizes } from 'theme/theme'

import { StyledIcon } from './styles'
import type { GeneratedIconProps } from './types'

export const GeneratedIcon = ({
  size: propsSize = 'medium',
  color,
  className,
  children,
  ...rest
}: PropsWithChildren<GeneratedIconProps>) => {
  const size = propsSize ? iconSizes[propsSize] : iconSizes.medium
  return (
    <StyledIcon
      className={classNames('icon', className)}
      $color={color}
      $size={size}
      {...rest}
    >
      {children}
    </StyledIcon>
  )
}
